export class Version {

    public gitHashShort: string;

    constructor(public major: string,
        public minor: string,
        public buildNumber: string,
        public gitHash: string,
        public gitBranch: string) {
            this.gitHashShort = this.gitHash ? this.gitHash.substring(0, 6) : '';
        }

    public toString = () : string => {
        return `${this.major}.${this.minor}.${this.buildNumber}`;
    };
}



// WEBPACK FOOTER //
// ./src/app/shared/classes/version.ts